import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from '../../theme';
import { BASE_IMAGE_URL } from '../../configs/constants';

import ZeroState from './ZeroState'
import axios from 'axios';
import { endpoints } from '@app/api/apis';
import { useAppDispatch, useAppSelector } from '@app/store/hooks';
import { useEffect, useState,useCallback } from 'react';
import TransactionOverview from './components/TransactionOverview';
import { FlatList, ScrollView,ActivityIndicator } from 'react-native';
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet';
import TransactionDetails from './components/TransactionDetails';
import EmailIcon from '../../../assets/Icons/Email';
import EmailSentSuccess from './components/EmailSentSuccess';
import { useFocusEffect } from '@react-navigation/native';
import { isEmpty } from 'lodash';
import handleApiErr from '@app/helper/handleApiErr';
import { showErrorSheet } from '@app/store/slices/errorSlice';
import Loading from '@app/sharedComponents/Loading/Loading';
import BackButton from '@app/sharedComponents/BackButton/BackButton';
import { useDarkMode } from '@app/utils';

export const TRANSACTION_SCREEN = BASE_IMAGE_URL +
  'Empty_Trans.png';


function TransactionScreen({navigation,route}) {
  const userDetails = useAppSelector((state) => state?.auth?.userDetails);
  const {isfromTDL} = useAppSelector(state => state.platformParams);
  const [transactionDetail,setTransactionDetail] = useState({})
  const [bottomSheetType, setBottomSheetType] = useState(null);
  const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
  const [inProgressTransactions, setInProgressTransactions] = useState([])
  const [settledTransactions, setSettledTransactions] = useState([])
  const [isMoreThanHundred, setIsMoreThanHundred] = useState(false)
  const [loading, setLoading] = useState(true);
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const isLMSUser = useAppSelector((state) => state.commonReducer.isLMSUser);
  const dispatch = useAppDispatch()
  const isDarkMode = useDarkMode()
  const fetchTransactionHistory = () => {
    setLoading(true)
    const url= endpoints.transactionHistory + userDetails?.linkedBorrowerAccounts[0]?.accountId;
    axios.get(url).then((res)=>{
      setIsMoreThanHundred(res?.data[0]?.transactionList?.length >= 100)
      const inProgressTransaction = []
      const settledTransaction = []
      let obj ={}
      res?.data[0]?.transactionList.forEach((element:any) => {
        if(element?.transactionId === route?.params?.transactionId){
          obj = element
        }
        if(element?.transactionStatus === "PENDING_SETTLEMENT"){
          inProgressTransaction.push(element)
        }
        else{
          settledTransaction.push(element)
        }
      });
      setInProgressTransactions(inProgressTransaction)
      // const sortedSettledTransaction = settledTransaction.sort((a:any,b:any)=>new Date(b?.settledOn).getTime() - new Date(a?.settledOn).getTime())
      // setSettledTransactions(sortedSettledTransaction)


      // Group transactions by month
      const groupedTransactions = settledTransaction.reduce((acc: any, transaction: any) => {
        const month = new Date(transaction.settledOn).toLocaleString('default', { month: 'long', year: 'numeric' });
        if (!acc[month]) {
          acc[month] = [];
        }
        acc[month].push(transaction);
        return acc;
      }, {});

      setSettledTransactions(groupedTransactions);
      if(route?.params?.transactionId && !isEmpty(obj)){
        openTransactionDetails(obj)
      }
    }).catch((err)=>{
      console.log('err',err)
    }).finally(()=>{
      setLoading(false)
    })
  }

  const sendEmail = () => {
    setIsSendingEmail(true)
    const url = endpoints.transactionEmail + userDetails?.linkedApplications[0]?.accountId;
    axios.get(url).then((res)=>{
      console.log('sendEmail',res?.data);
      setIsBottomSheetVisible(true);
      setBottomSheetType('EMAIL');
    }).catch((err)=>{
      console.log('sendEmail',err)
      if(handleApiErr(err)){
        dispatch(showErrorSheet({
            isErrorSheetVisible: true,
            errorMessage: err?.data?.message,
            closeOnBackdropPress: true,
            errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
            errorHeading: err?.data?.header || '',
            showErrorHeading: false,
            btnName:'Try again later',
        }))
    }
    }).finally(()=>{
      setIsSendingEmail(false)
    })
  }
  useFocusEffect(
    useCallback(() => {
      // Do something when the screen is focused
      fetchTransactionHistory()
      return () => {
        // Do something when the screen is unfocused
        // Useful for cleanup functions
      };
    }, [])
  );

  const openTransactionDetails = (transaction:any) => {
    if(isBottomSheetVisible){
      return
    }
    setIsBottomSheetVisible(true)
    setTransactionDetail(transaction)
    setBottomSheetType('TRANSACTIONDETAILS')
  }

  const closeBottomSheet = ()=>{
    if(isBottomSheetVisible){
    setIsBottomSheetVisible(false);
    setBottomSheetType(null)
    // setTimeout(()=>{setTransactionDetail({})},500)
  }
  }

  const sortedSettledTransaction = Object.keys(settledTransactions)

  if(loading){
    return(
    <Loading/>
    )
  }
  return (
    <>
    <ThemedView px="lg" py="md" borderBottomWidth={1} borderBottomColor='border-secondary' backgroundColor='bg-surface-primary'>
      <ThemedView  flexDirection='row'  alignItems='center' justifyContent='space-between'>
        <ThemedView flexDirection='row' alignItems='center'>
         {isfromTDL && <ThemedView mr="sm">
          <BackButton navigation={navigation} />
          </ThemedView>}
        <ThemedText variant='h5s' color='text-primary' >Transactions</ThemedText>
        </ThemedView>
        {!isfromTDL && isLMSUser && 
        <ThemedPressable 
          hitSlop={15}
          disabled={isSendingEmail}
          onPress={sendEmail}
          flexDirection='row' 
          alignItems='center' 
          backgroundColor='bg-fill-emphasis-primary-1' 
          py='xs' px='sm' borderRadius='xl'>
          <EmailIcon size={12} bgColor={themeColorSet['bg-fill-emphasis-primary-1']} color={themeColorSet['icon-action-primary']} />
          <ThemedText variant='b5m' textTransform='uppercase' color={isDarkMode? 'text-on-action-primary' : 'text-action-primary'} ml='xs' >Email</ThemedText>
          {isSendingEmail && <ActivityIndicator size={12} color={themeColorSet['bg-action-primary']} style={{marginLeft: 4}} />}
        </ThemedPressable>}
        </ThemedView>
    </ThemedView>
    {inProgressTransactions.length ===0  && sortedSettledTransaction.length===0 ?
      <ThemedView pt="md" flex={1} backgroundColor='bg-surface-primary' >
        <ZeroState isLMSUser={isLMSUser} />
      </ThemedView> : 
    <>
      <ScrollView style={{flex: 1,  backgroundColor:isfromTDL?'#fff':themeColorSet['bg-surface-page'] ,paddingBottom: 16}}>
          {inProgressTransactions.length > 0 &&
            <>
            <ThemedText variant="h5s" color="text-primary" mt="2xl" mb="sm" mx="lg">Transactions under processing</ThemedText>
            <ThemedView backgroundColor='bg-fill-primary' px="lg" {...isfromTDL && {borderWidth:1,borderColor:'border-primary',borderRadius:'sm' ,m:"lg"}}>
            <FlatList
                data={inProgressTransactions}
                keyExtractor={item => item?.lenderTransactionId}
                initialNumToRender={20} // Increased from default 10
                maxToRenderPerBatch={20}
                renderItem={({item, index, separators}) => (<TransactionOverview data={item} index={index} onClick={openTransactionDetails}/>)}
              />
              </ThemedView>
            </>
          }
         {sortedSettledTransaction?.length > 0 && <ThemedText variant="h5s" color="text-primary" mt="2xl"  mb="sm" mx="lg">Completed transactions</ThemedText>}
          {
          sortedSettledTransaction?.length > 0 &&
          sortedSettledTransaction?.map((monthName:string,)=>{
            return(
              <>
                {isfromTDL && <ThemedText variant='b3r' mx="lg" color='text-secondary' textTransform='uppercase' >{monthName}</ThemedText>}
                <ThemedView backgroundColor='bg-fill-primary' px="lg" {...isfromTDL && {borderWidth:1,borderColor:'border-primary',borderRadius:'sm' ,m:"lg"}} >
                  {
                    !isfromTDL && 
                    <>
                    <ThemedText variant='b3r'color='text-secondary' textTransform='uppercase' my="lg" >{monthName}</ThemedText>
                    <ThemedView width={'100%'} height={1} backgroundColor="border-secondary" />
                    </>
                  }
                  <FlatList
                    data={settledTransactions[monthName]}
                    keyExtractor={item => item?.lenderTransactionId}
                    initialNumToRender={20} // Increased from default 10
                    maxToRenderPerBatch={20}
                    renderItem={({item, index, separators}) => (<TransactionOverview isfromTDL={isfromTDL} data={item} index={index} onClick={openTransactionDetails}/>)}
                  />
                </ThemedView>

              </>
            )
          })
          }
          {
            isMoreThanHundred &&
            <ThemedView flex={1} justifyContent='center' alignItems='center' backgroundColor='bg-fill-primary'  p="lg" borderTopWidth={1} borderTopColor='border-primary'>
              <ThemedText variant='b5m' color='text-primary' >Looking for older transactions?</ThemedText>
              <ThemedView mt="xs" flexDirection='row' alignItems='center'>
              <ThemedText variant='b5m' color='text-primary'>To receive complete transaction history over email. </ThemedText>
              <ThemedPressable flexDirection='row' alignItems='center' onPress={sendEmail}>
                <ThemedText variant='b5r' color='text-action-primary' >Click here </ThemedText>
                {isSendingEmail && <ActivityIndicator size={12} color={themeColorSet['bg-action-primary']} />}
              </ThemedPressable>
              </ThemedView>
            </ThemedView>
          }
      </ScrollView>

      {/* Bottom sheet container */}
      <BottomSheetContainer
        isVisible={isBottomSheetVisible}
        close={closeBottomSheet}
        closeOnBackdropPress={true}
        borderTopRightRadius={10}
        borderTopLeftRadius={10}
        showCloseIcon
        >
        {bottomSheetType==="EMAIL" && <EmailSentSuccess isTransactionsEmail={true} closeBottomSheet={closeBottomSheet}/>}
        {bottomSheetType==="TRANSACTIONDETAILS" &&
        <TransactionDetails
          onClose={closeBottomSheet}
          transactionDetail={transactionDetail}
        />}
      </BottomSheetContainer>
    </>
    }
    </>
  );
}

export default TransactionScreen;
